export function Footer(): JSX.Element {
  return (
    <footer className="py-6 text-center">
      <p>Copyright by Dahveed - 2026.</p>
    </footer>
  )
}
